import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { PropertyEditorShowAction } from '@src/js/constant';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IRightSideBarService } from '@src/slide/application/service/right-side-bar-service/core/interface';

@Feature()
export class InsertFooterFeature extends BaseToolbarFeature {
    id = config.id;
    constructor() {
        super();
    }

    public handleClick(): void {
        this.getSelectionService().selectedElements.clear();

        this.getRightSideBarManager()?.setPropertyEditorShowAction(PropertyEditorShowAction.INSERT_FOOTER);
        this.getRightSideService()?.hide();
    }

    private getRightSideBarManager(): IRightSideBarManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.rightSideBarManager;
    }

    private getRightSideService(): IRightSideBarService | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer?.rightSideBarService;
    }
}
